

// import React, { Fragment } from "react";
// import styled from "styled-components";
// import clockImage from "../assets/comming-soon.png";

// export default function BursaryApplicationNotice() {
//   return (
//     <Fragment>
//       <Spacer height="40px" />

//       <Title>Application for Bursary Scholarship</Title>

//       <Spacer height="20px" />

//       <ImageWrapper>
//         <Image src={clockImage} alt="Clock" />
//       </ImageWrapper>

//       <Spacer height="10px" />

//       <ContentWrapper>
//         <Notice>Notice:</Notice>
//         <Description>
//           The application process will be open from <b>12th November 2025</b>.
//           <br />
        //   Until then, download the Income Certification Form and obtain the 
        // certification from the relevant authorities. Keep it ready in PDF 
        // format (<b>2Mb Max.</b>) to upload during the application process.
//         </Description>
//       </ContentWrapper>
//     </Fragment>
//   );
// }

// // -------------------- styled-components -------------------- //

// const Spacer = styled.div`
//   height: ${(props) => props.height || "20px"};
// `;

// const Title = styled.h1`
//   text-align: center;
//   color: #229918;
//   font-size: 25px;
//   margin: 0;
//   padding: 0 10px;

//   @media (max-width: 768px) {
//     font-size: 20px;
//   }

//   @media (max-width: 480px) {
//     font-size: 18px;
//   }
// `;

// const ImageWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

// const Image = styled.img`
//   width: 100px;
//   max-width: 80%;
//   height: auto;
//   object-fit: contain;

//   @media (max-width: 768px) {
//     width: 100px;
//   }

//   @media (max-width: 480px) {
//     width: 100px;
//   }
// `;

// const ContentWrapper = styled.div`
//   max-width: 50%;
//   margin: 0 auto;
//   text-align: left;
//   padding: 0 15px;

//   @media (max-width: 768px) {
//     max-width: 80%;
//   }

//   @media (max-width: 480px) {
//     max-width: 95%;
//   }
// `;

// const Notice = styled.p`
//   color: #fbcd13;
//   font-weight: bold;
//   font-size: 16px;
// `;

// const Description = styled.p`
//   color: black;
//   font-size: 15px;
//   line-height: 1.6;

//   @media (max-width: 480px) {
//     font-size: 14px;
//   }
// `;



import { Calendar, Download, Info, FileDown } from "lucide-react";
import styled from "styled-components";

// Global Styles
const GlobalStyle = styled.div`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
`;

const Container = styled.div`
  min-height: 100vh;
  background: white;
  padding: 1.5rem 1rem;

  @media (min-width: 640px) {
    padding: 2rem 1.5rem;
  }

  @media (min-width: 1024px) {
    padding: 2.5rem 2rem;
  }
`;

const MaxWidthWrapper = styled.div`
  max-width: 80rem;
  margin: 0 auto;
`;

const HeaderSection = styled.div`
  text-align: center;
  margin-bottom: 1.5rem;

  @media (min-width: 640px) {
    margin-bottom: 2rem;
  }
`;

const Title = styled.h1`
  color: #16a34a;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;

  @media (min-width: 640px) {
    font-size: 1.75rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    font-size: 2rem;
    line-height: 1.5;
  }
`;

const InfoBanner = styled.div`
  background: #dbeafe;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  max-width: 100%;
`;

const InfoText = styled.p`
  color: #334155;
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }
`;

const InfoHighlight = styled.span`
  color: #0f172a;
  font-weight: 500;
`;

const ContentGrid = styled.div`
  display: grid;
  gap: 1.25rem;
  max-width: 64rem;
  margin: 0 auto 1.25rem auto;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

const Card = styled.div`
  background: #f8fafc;
  padding: 1.25rem;
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

const IconWrapper = styled.div`
  padding: 0.5rem;
  background: ${props => props.$bgColor};
  border-radius: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CardTitle = styled.h2`
  color: #0f172a;
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 1.125rem;
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Description = styled.p`
  color: #475569;
  margin: 0;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }
`;

const DownloadButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  background: #16a34a;
  color: white;
  padding: 0.625rem 1rem;
  border-radius: 0.375rem;
  border: none;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  align-self: flex-start;
  line-height: 1.5;
  min-height: 44px;
  white-space: nowrap;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }

  &:hover {
    background: #15803d;
  }

  &:active {
    background: #166534;
  }

  &:focus {
    outline: 2px solid #16a34a;
    outline-offset: 2px;
  }
`;

const RequirementsSection = styled.div`
  max-width: 64rem;
  margin-left: auto;
  margin-right: auto;
`;

const RequirementsBox = styled.div`
  background: #f8fafc;
  padding: 1.25rem;
  border-radius: 0.75rem;

  @media (min-width: 640px) {
    padding: 1.5rem;
  }
`;

const RequirementsLabel = styled.p`
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 0.75rem 0;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }
`;

const RequirementsList = styled.div`
  display: grid;
  gap: 0.75rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const RequirementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const CheckIcon = styled.svg`
  width: 1.25rem;
  height: 1.25rem;
  color: #16a34a;
  flex-shrink: 0;
`;

const RequirementText = styled.span`
  color: #334155;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }
`;

const Footer = styled.div`
  margin-top: 1.5rem;
  text-align: center;

  @media (min-width: 640px) {
    margin-top: 2rem;
  }
`;

const FooterText = styled.p`
  color: #64748b;
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0;
  line-height: 1.5;

  @media (min-width: 640px) {
    font-size: 0.9375rem;
  }
`;

export default function App() {
  const handleDownload = () => {
    const fileUrl = "https://usjnetsso.sjp.ac.lk/sso/assets/usjnet_doc/Downloads/Income Certification Form for Bursaries - USJ (1).pdf"; 
    const fileName = "report.pdf"; 

    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    link.target = "_blank"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <GlobalStyle />
      <Container>
        <MaxWidthWrapper>
          <HeaderSection>
            <Title>Application for Bursary Scholarship</Title>
            
            <InfoBanner>
              <Info className="w-4 h-4 text-blue-600" style={{ flexShrink: 0 }} />
              <InfoText>
                The application process will be open from <InfoHighlight>12th November 2025</InfoHighlight>
              </InfoText>
            </InfoBanner>
          </HeaderSection>

          <ContentGrid>
            <Card>
              <CardHeader>
                <IconWrapper $bgColor="#dbeafe">
                  <Calendar className="w-5 h-5 text-blue-700" />
                </IconWrapper>
                <CardTitle>Application Timeline</CardTitle>
              </CardHeader>
              <CardContent>
                <Description>
                  Start Date: <b>19.11.2025</b> 
                </Description>

                <Description>
                  Closing Date: <b>03.12.2025</b> 
                </Description>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <IconWrapper $bgColor="#dcfce7">
                  <Download className="w-5 h-5 text-green-700" />
                </IconWrapper>
                <CardTitle>Document Preparation</CardTitle>
              </CardHeader>
              <CardContent>
                <Description>
                Download the Income Certification Form and obtain the 
                certification from the relevant authorities. Keep it ready in PDF 
                format (<b>2MB Max.</b>) to upload during the application process.
                </Description>
                <DownloadButton onClick={handleDownload}>
                  <FileDown className="w-4 h-4" />
                  Download Form
                </DownloadButton>
              </CardContent>
            </Card>
          </ContentGrid>

          {/* <RequirementsSection>
            <RequirementsBox>
              <RequirementsLabel>Document Requirements:</RequirementsLabel>
              <RequirementsList>
                <RequirementItem>
                  <CheckIcon fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </CheckIcon>
                  <RequirementText>PDF format only</RequirementText>
                </RequirementItem>
                <RequirementItem>
                  <CheckIcon fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </CheckIcon>
                  <RequirementText>Max size: 2MB</RequirementText>
                </RequirementItem>
                <RequirementItem>
                  {/* <CheckIcon fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </CheckIcon> 
                  {/* <RequirementText>Properly certified</RequirementText> 
                </RequirementItem>
              </RequirementsList>
            </RequirementsBox>
          </RequirementsSection> */}

         
        </MaxWidthWrapper>
      </Container>
    </>
  );
}
